import { Component, OnInit, EventEmitter, Output, Input, ViewChild} from '@angular/core';
import { Keys,Labels } from '../../app/gasflow.constants';
import { UnitsService,Quantity,Pipe } from 'pumpcalc-core';

@Component({
  selector: 'app-pipe-form',
  templateUrl: './pipe-form.component.html',
  styleUrls: ['./pipe-form.component.css']
})

export class PipeFormComponent implements OnInit {

  pipe:Pipe = new Pipe("1");
  @Input() pipes:Pipe[]=[this.pipe];
  @Output() pipeAdded: EventEmitter<Pipe> = new EventEmitter();
  @Output() change: EventEmitter<Pipe[]> = new EventEmitter();
  @Output() editing: EventEmitter<boolean> = new EventEmitter();
  @ViewChild("standardPipeSelector") standardPipeSelector:any;
  @Input() errors = {};
  keys = Keys;
  labels = Labels;
  length=10;
  lastSelectedStandardPipe;
  sections=[Labels[Keys.circular],Labels[Keys.annular],Labels[Keys.rectangular]];
  quantity=Quantity;

  constructor(public unitsService:UnitsService){}

  ngOnInit(): void {
    this.pipes[0].entrance=true;
  }

  applyStandardPipe(standardPipe){
    this.lastSelectedStandardPipe = standardPipe;
    this.pipes[0].xdim1 = standardPipe.diameter;
    this.pipes[0].section = "Circular";
    this.change.emit(this.pipes);
  }

  valueChanged(){
    if((this.lastSelectedStandardPipe && this.lastSelectedStandardPipe.diameter != this.pipes[0].xdim1) || this.pipes[0].section != "Circular" ){
      this.standardPipeSelector.clearSelection();
    }
    this.change.emit(this.pipes);
  }

  addPipe(){
    this.pipes.push(new Pipe(this.pipes.length+1+""));
    this.change.emit(this.pipes);
  }

  listChanged(event){
    if(this.pipes.length == 0){
      this.pipes[0] =   new Pipe(this.pipes.length+1+"");
    }
    if(!this.pipes[0].entrance){this.pipes[0].entrance=true;
      this.pipes=this.clone(this.pipes);
    }
    this.change.emit(this.pipes);
  }

  pipeClick($event){
  }

  clone(obj:any):any{
    return JSON.parse(JSON.stringify(obj));
  }

  editingPipes(state:boolean){
    this.editing.emit(state);
  }

}
